import { Check, X } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

const good = [
  "Families wanting seamless comfort, top-tier logistics, and absolute safety for kids or parents.",
  "Busy corporate professionals who have limited leave days and refuse to spend them stressed.",
];
const bad = [
  "You are hunting for the cheapest, lowest-cost budget package available in the market.",
  "You prefer a packed, hyper-rigid schedule that squeezes 15 crowded spots into one day.",
];

export const Qualification = () => (
  <section className="bg-white px-7 py-24 sm:px-12 lg:px-20 lg:py-32" data-testid="qualification-section">
    <div className="mx-auto max-w-6xl">
      <Reveal className="max-w-3xl">
        <p className="eyebrow text-gold mb-5">The Client Filter</p>
        <h2 className="font-display text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl">
          Is This Experience Right <span className="italic text-gold">For Your Family?</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:gap-14">
        <Reveal>
          <div className="h-full border-t-2 border-gold bg-[#FBFAF6] p-8 lg:p-10">
            <h3 className="font-display text-2xl text-ink">This is perfect for you if…</h3>
            <ul className="mt-8 space-y-6">
              {good.map((g) => (
                <li key={g} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold">
                    <Check className="h-3.5 w-3.5 text-ink" strokeWidth={3} />
                  </span>
                  <span className="text-base leading-relaxed text-ink/80">{g}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="h-full border-t-2 border-black/20 bg-[#F7F7F6] p-8 lg:p-10">
            <h3 className="font-display text-2xl text-ink/70">This is definitively NOT for you if…</h3>
            <ul className="mt-8 space-y-6">
              {bad.map((b) => (
                <li key={b} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-black/25">
                    <X className="h-3.5 w-3.5 text-black/50" strokeWidth={3} />
                  </span>
                  <span className="text-base leading-relaxed text-black/50">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
